import React from 'react';
import classes from './AuctionDashSkeleton.module.scss';

const AuctionDashSkeleton = () => {
    return (
        <div className={classes.skeletonCard}>
            <div className={classes.imageContainer}>
                <div className={classes.image}></div>
            </div>
            <div className={classes.content}>
                <div className={classes.title}></div>
                <div className={classes.details}>
                    <div className={classes.detail}></div>
                    <div className={classes.detail}></div>
                </div>
            </div>
        </div>
    );
};

export default AuctionDashSkeleton;